module.exports = __webpack_public_path__ + "img/sj_warning_img.961380d0.png";